import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        update: '&',
        cancel: '&',
        formId: '='
    },
    template: `
        <div class="modal-header">
            <button type="button" class="close" ng-click="vm.cancel()"></button>
            <h2>{{ 'question.Import question' | translate }}</h2>
        </div>
        <modals-question-import-file
            ng-if="vm.step === 1"
            step="vm.step"
            set-step="vm.setStep(step)"
            update="vm.update()"
        />
        <modals-question-import-organize
            ng-if="vm.step === 2"
            form-id="vm.formId"
            set-summary="vm.setSummary(summary)"
            step="vm.step"
            set-step="vm.setStep(step)"
            update="vm.update()"
        />
        <modals-question-import-errors
            ng-if="vm.step === 3"
            set-summary="vm.setSummary(summary)"
            summary="vm.summary"
            update="vm.update()"
            step="vm.step"
            set-step="vm.setStep(step)"
        />
        <modals-question-import-summary
            ng-if="vm.step === 4"
            step="vm.step"
            summary="vm.summary"
            update="vm.update()"
        />
    `
})
export default class {
    setStep (step) {
        this.step = step;
    }

    setSummary (summary) {
        this.summary = summary;
    }

    $onInit () {
        this.step = 1;
        this.summary = {};
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/question/import/index.js